export default __webpack_public_path__ + "static/media/banner1.67fead28.jpg";